<template>
    <custom-dialog type="warning" title="退号确认" :showClose="true" width="358px" v-if="visibleObj.returnComfirmDialog"
        :visible="visibleObj.returnComfirmDialog" @close="dialogVisible('returnComfirmDialog')" @save="comfirm">
        <div slot="content">退号后不可恢复，确定退号？</div>
    </custom-dialog>
</template>
  
<script>
import customDialog from '@/components/customDialog/CustomDialog'
export default {
    // 定义引入的组件
    components: { customDialog },
    props: {
        visibleObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 关闭
         */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 确认
         */
        comfirm() {
            this.$emit('updateData')
        },

    },
}
</script>
<style lang="less" scoped></style>